export const cleanPhone = (jid) => {
  if (!jid) return "";
  // @lid JIDs are WhatsApp internal device identifiers, NOT real phone numbers
  if (jid.includes("@lid")) return "";
  // Strip @s.whatsapp.net, @g.us etc, then strip :device suffix
  const num = (jid.split("@")[0] || "").split(":")[0];
  // Add + prefix only if purely numeric and valid E.164 length (7–15 digits)
  if (num && /^\d{7,15}$/.test(num)) return "+" + num;
  // Group IDs contain dashes — return cleaned but no +
  return num || jid;
};

export const timeAgo = (date) => {
  if (!date) return "";
  const d = typeof date === "string" ? new Date(date) : date;
  const diff = Date.now() - d.getTime();
  if (diff < 60000)     return "just now";
  if (diff < 3600000)   return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000)  return `${Math.floor(diff / 3600000)}h ago`;
  if (diff < 604800000) return `${Math.floor(diff / 86400000)}d ago`;
  return d.toLocaleDateString([], { month: "short", day: "numeric" });
};

export const formatTime = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

export const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return "Today";
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return "Yesterday";
  return d.toLocaleDateString([], { weekday: "long", month: "short", day: "numeric" });
};

export const truncate = (str, n = 60) =>
  str && str.length > n ? str.slice(0, n) + "…" : str || "";